import React from "react";
import { motion } from "framer-motion";
import {
    ShoppingCart,
    ShieldCheck,
    Sparkles,
    CalendarCheck,
    Timer,
    TagsIcon,
} from "lucide-react";

const ITEMS = [
    {
        icon: ShoppingCart,
        title: "Compra inteligente",
        desc: "Leve pra casa aquilo que realmente faz sentido para você.",
    },
    {
        icon: ShieldCheck,
        title: "Mais segurança",
        desc: "Alergias e restrições sempre em primeiro lugar no seu perfil.",
    },
    {
        icon: Sparkles,
        title: "Menos complicação",
        desc: "Chega de decifrar letras miúdas, tabelas e ingredientes técnicos.",
    },
    {
        icon: CalendarCheck,
        title: "Melhor rotina",
        desc: "Escolhas diárias alinhadas ao seu objetivo, sem esforço extra.",
    },
    {
        icon: Timer,
        title: "Economia de tempo",
        desc: "Decida em segundos no corredor do mercado, sem travar a compra.",
    },
    {
        icon: TagsIcon,
        title: "Ofertas inteligentes",
        desc: "Descubra alternativas melhores, mais baratas e do seu jeito.",
    },
];

export default function Beneficios() {
    return (
        <section
            id="beneficios"
            data-testid="beneficios-section"
            className="relative py-20 md:py-28"
        >
            <div className="max-w-7xl mx-auto px-6 lg:px-8">
                <motion.div
                    initial={{ opacity: 0, y: 24 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-80px" }}
                    transition={{ duration: 0.6 }}
                    className="max-w-3xl"
                >
                    <span className="text-xs uppercase tracking-[0.2em] font-bold text-[#16A34A]">
                        Benefícios
                    </span>
                    <h2 className="mt-3 font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold text-[#0B1C3A] tracking-tight">
                        Por que usar o Dentro?
                    </h2>
                </motion.div>

                <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
                    {ITEMS.map((it, i) => {
                        const Icon = it.icon;
                        return (
                            <motion.div
                                key={it.title}
                                initial={{ opacity: 0, y: 24 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true, margin: "-80px" }}
                                transition={{ duration: 0.55, delay: i * 0.05 }}
                                data-testid={`benefit-card-${i + 1}`}
                                className="bg-[#F8FAFC] rounded-3xl p-7 hover:bg-white hover:shadow-[0_18px_50px_rgba(11,28,58,0.06)] transition-all border border-transparent hover:border-slate-100"
                            >
                                <div className="h-12 w-12 rounded-2xl bg-white border border-slate-100 grid place-items-center text-[#16A34A] shadow-sm">
                                    <Icon size={22} strokeWidth={2.25} />
                                </div>
                                <h3 className="mt-5 font-display text-xl font-extrabold text-[#0B1C3A]">
                                    {it.title}
                                </h3>
                                <p className="mt-2 text-[15px] text-[#475569] leading-relaxed">
                                    {it.desc}
                                </p>
                            </motion.div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}
